import "antd/dist/antd.min.css";
import { QueryClient, QueryClientProvider } from "react-query";
import LayoutProvider from "./context/LayoutContext";
import { CustomRoutes } from "./routes";
const queryClient = new QueryClient();

function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <LayoutProvider>
                <CustomRoutes />
            </LayoutProvider>
        </QueryClientProvider>
    );
}

export default App;
export { queryClient };
